import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { LoadingSpinner } from '../../../shared/ui';
import {
  AdminBlogShell,
  AdminPageHeader,
  AdminReviewEditorFields,
  appendYowanContentPreviewQuery,
  useAdminContentMediaOptions,
  usePreservedDomainSearch,
} from './AdminBlogListPage';
import {
  createYowanAdminFounderCassette,
  getYowanAdminMutationErrorMessage,
} from '../app/yowanContentClient';
const { yowanPageContent } = require('./pageContent');

const AdminFounderCreatePage = () => {
  const content = yowanPageContent['/admin/content/founder/new'];
  const navigate = useNavigate();
  const preservedDomainSearch = usePreservedDomainSearch();
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    mediaAssetOptions,
    mediaAssetLoading,
    mediaAssetError,
  } = useAdminContentMediaOptions('founder');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: content?.form.defaults,
  });

  if (!content) {
    return null;
  }

  const onSubmit = async (formValues) => {
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const created = await createYowanAdminFounderCassette(formValues);
      setSubmitMessage('保存しました。');
      if (created?.id) {
        navigate(appendYowanContentPreviewQuery('/admin/content/founder', preservedDomainSearch));
      }
    } catch (error) {
      setSubmitMessage(getYowanAdminMutationErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminBlogShell activeNavHref="/admin/content/founder" routeKey="/admin/content/founder/new">
      <AdminPageHeader
        title={content.header.title}
        paragraphs={content.header.paragraphs}
        actions={[
          <Link key="back-to-list" to={appendYowanContentPreviewQuery('/admin/content/founder', preservedDomainSearch)}>
            一覧へ戻る
          </Link>,
        ]}
      />

      <form className="yowan-admin-form c-surface-content" onSubmit={handleSubmit(onSubmit)}>
        <AdminReviewEditorFields
          content={content}
          register={register}
          errors={errors}
          mediaAssetOptions={mediaAssetOptions}
          mediaAssetLoading={mediaAssetLoading}
          mediaAssetError={mediaAssetError}
        />

        <div className="yowan-admin-form__actions">
          <button type="submit" className="c-form__submit" disabled={isSubmitting}>
            {content.form.submitLabel}
          </button>
        </div>

        {isSubmitting ? (
          <p className="yowan-admin-form__message yowan-admin-form__message--pending">
            <LoadingSpinner inline size="sm" />
            <span>{content.form.pendingMessage}</span>
          </p>
        ) : submitMessage ? (
          <p className="yowan-admin-form__message">{submitMessage}</p>
        ) : null}
      </form>
    </AdminBlogShell>
  );
};

export default AdminFounderCreatePage;
